import { createFileRoute } from "@tanstack/react-router";
import AdviceSection from "@/pages/AdviceSection";

export const Route = createFileRoute("/advice/$sectionSlug")({
  component: AdviceSection,
});
